'use strict';

const Mn = require('backbone.marionette');
const ToggleNav = require('common/ui/view/behavior/togglenav');
const Template = require('balus/ui/template/body/project/app-tab.hbs');

const View = Mn.View.extend({
    template: Template,

    templateContext: function() {
        return {
            path: this.model.path(),
            project: this.getOption('project'),
            process: this.getOption('process'),
            diagram: this.getOption('diagram'),
            dataContent: this.getOption('dataContent'),
            hideNavToggle: this.getOption('hideNavToggle')
        };
    }
});

module.exports = Mn.View.extend({
    template: function() {return '<div class="wrapper"></div>'},
    regions: {
        wrapper: '.wrapper',
    },
    behaviors: [ToggleNav],

    onRender: function() {
        const view = new View({
            model: this.model,
            project: this.getOption('project'),
            process: this.getOption('process'),
            diagram: this.getOption('diagram'),
            dataContent: this.getOption('dataContent'),
            hideNavToggle: this.getOption('hideNavToggle')
        });

        this.showChildView('wrapper', view);
    },

    openNav: function() {
        const toggleNav = new ToggleNav();
        toggleNav.open();
    },

    closeNav: function() {
        const toggleNav = new ToggleNav();
        toggleNav.close();
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/project/app-tab.js